export const newCriterionId = 'new'

export const duplicateCriterionIdPrefix = 'duplicate-'

export const initCriterion = {
  id: null,
  internal_id: null,
  name: '',
  description: '',
  conditions: [],
  block_uids: [],
}
